export const SchoolId = '64904fb7e2328de84f6105d1';